import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  container: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  content: {
    padding: theme.spacing(2),
  },
  contentSplitter: {
    flexGrow: 1,
  },
  pdfViewer: {
    height: '55vh',
  },
  downContainer: {
    padding: theme.spacing(2),
  },
  formulario: {},
  corpoFormulario: {
    marginTop: theme.spacing(1),
  },
  item: {
    marginTop: theme.spacing(2),
  },
  botoesFormulario: {
    marginTop: theme.spacing(5),
  },
  textAreaTitle: {
    fontWeight: 'bold',
  },
  uploadContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  botaoAnexar: {
    color: theme.palette.primary.contrastText,
  },
  formNecropapiloscopico: {
    paddingBottom: '20px',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  uploadButton: {
    display: 'none', // Ocultar o input real
  },
  customUploadButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 8,
    color: theme.palette.secondary.contrastText,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
      transform: 'translateY(-1px)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
    marginTop: theme.spacing(2.5),
  },
  datePicker: {
    width: '300px',
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
  groupFiliacao: {
    marginTop: theme.spacing(1),
  },
  inputForm: {
    marginBottom: theme.spacing(1),
  },
  botaoAddFiliacao: {
    marginLeft: theme.spacing(1),
  },
}))
